import * as types from './types'

export const mutations = {
    [types.SET_ENV](state, env) {
        state.environment = env
    },

    [types.SET_CELLPHONE](state, cellphone) {
        state.cellphone = cellphone
    },

    [types.SET_ACTIVITYDATA](state, activityData) {
        state.activityResp = activityData
    },

    [types.SET_FILLINFO](state, fillinfo) {
        state.fillinfo = fillinfo
    },

    [types.SET_LESSON](state, lesson) {
        state.lesson = lesson
    },

    [types.SET_PROFILE](state, profile) {
        state.profile = profile
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js